export default "__VITE_ASSET__DY8ep0Rt__"